import React, { useEffect, useState } from 'react';
import driverApi from '../../clients/DriverClient';
import { type Membership } from '../../models/Membership';
import { Link } from 'react-router-dom';

interface DashboardActionsProps {
    driverId?: string;
}

const DashboardActions: React.FC<DashboardActionsProps> = ({ driverId }) => {
    const [membership, setMembership] = useState<Membership | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');

    useEffect(() => {
        const fetchMembership = async () => {
            if (!driverId) {
                setMembership({ id: '', name: 'None', bookingLinks: [] });
                return;
            }
            setIsLoading(true);
            setError('');
            try {
                const result = await driverApi.getMembershipByDriverId(driverId);
                setMembership(result);
            } catch (e) {
                setError('Failed to load membership');
            } finally {
                setIsLoading(false);
            }
        };
        fetchMembership();
    }, [driverId]);

    return (
        <div>
            {isLoading && (
                <div className="text-center py-4">
                    <span className="spinner-border text-primary" role="status" aria-hidden="true"></span>
                </div>
            )}

            {!isLoading && error && (
                <div className="alert alert-danger" role="alert">{error}</div>
            )}

            {!isLoading && !error && (
                <div className="d-flex flex-row align-items-md-center justify-content-between gap-2">
                    <div className="mb-2 mb-md-0 d-flex align-items-center gap-3">
                        {membership?.name !== 'None' && (
                            <div className="d-flex align-items-center">
                                <span className="badge">Membership: </span>
                                <span className="badge bg-success">{membership?.name}</span>
                            </div>
                        )}
                        <Link to="/booking"
                         className="btn btn-sm btn-primary text-nowrap dashboard-action-btn">
                            Book a Race
                        </Link>

                    </div>
                </div>
            )}
        </div>
    );
};

export default DashboardActions;


